import { TenantForm } from "components";

export default function EditTenant() {
	return (
		<div className="tenant-page">
			<TenantForm isEditForm />
		</div>
	);
}
